export enum QueueStatusFlag{
  Active = "Active",
  Called = "Called",
  Confirmed = "Confirmed",
  Assigned = "Assigned",
  Expired = "Expired",
  UserCancelled = "UserCancelled",
  StoreCancelled = "StoreCancelled"
}
